import React, { Component } from 'react';
import $ from 'jquery';

import AdminLayout from './layout';

import FetchCall from '../../API/FetchCall';

import { getBewiseUsersPaged, getTotalBewiseUsers } from '../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';
import { adminUser, userExport, deactivateUser, activateUser, commonAPI } from '../../API/FetchCall';

import Pagination from "react-js-pagination";
//import Pagination from 'rc-pagination';

import 'react-notifications/lib/notifications.css';
import {NotificationContainer, NotificationManager} from 'react-notifications';

import BeWiseLoading from '../../../src/assets/bewiseloading.gif';

class bewiseUsers extends Component {

    constructor(props) {
        super(props);
        var url = new URL(window.location.href);
        var location = url.searchParams.get("location");
        var auth_data = JSON.parse(localStorage.getItem("user_data"));
        this.state = {
              logged: localStorage.getItem("authentication"),
              auth_data: JSON.parse(localStorage.getItem("user_data")),
              location: location ? location.split('-') : [],
              bewiseUserList: [],
              PER_PAGE:15,
              total:0,
              loading:true,
              searchby:'',
              activePage:0,
              offset:0,
        };

        
    }


    componentDidMount() {

      var THIS = this;
      $(document).on('click', '.remove_user', function () {
          var delete_id = $(this).data("id");
          THIS.setState({
              delete_id: delete_id
          });
          THIS.deletUser(delete_id);
      });

      this.getTotal();
      this.getList();

    }


    deletUser(delete_id = '') {
      if(confirm("Are you sure to Deactivate this user?")== true) {
              let ins = JSON.stringify({
                  id: delete_id,
                  type: 5
              });
              deactivateUser(ins).then((res) => {
                  let toastr = '';
                  if (res.status === 1) {
                      
                      NotificationManager.success(res.message);

                      setTimeout(function () {
                          window.location.reload();
                      }, 2000);
                  } else {
                      
                      NotificationManager.error(res.message);
                  }
              });
          }
     }


    getTotal = (location='') => {


      const locationselected = (location=='')?this.state.location:location;

      let ins = JSON.stringify({
        location: locationselected,
        searchby:this.state.searchby,
      });

      getTotalBewiseUsers(ins).then((res) => {

        this.setState({loading:true});

        if (res.status == 1) {
                  
          this.setState({
            
            total: res.total
            
          });

        } 
      });

    }    

    getList = (pageNumber=1, location='') => {

      const { login_id, role } = this.state.auth_data;
      
      this.setState({activePage: pageNumber});

      const newOffset = (pageNumber==1)? 0 : (((pageNumber-1) * this.state.PER_PAGE)%this.state.total);

      const locationselected = (location=='')?this.state.location:location;

      let ins = JSON.stringify({
        vendor_id: login_id,
        role: role,
        location: locationselected,
        searchby:this.state.searchby,
        perpage:this.state.PER_PAGE,
        year: this.state.year,
        month: this.state.month,
        offset:newOffset
      });

      getBewiseUsersPaged(ins).then((res) => {


        this.setState({loading:true});

        if (res.status == 1) {

          this.setState({loading:!this.state.loading});
          
          this.setState({
            
            bewiseUserList: res.data
            
          });

        } else {

          this.setState({loading:!this.state.loading});
          
          this.setState({
            bewiseUserList: [],
          });
        }
      });


    }  

    handlePageChange(pageNumber) {

          console.log(`active page is ${pageNumber}`);

          this.setState({activePage: pageNumber});

          //this.getTotal('bw_schools');
          this.getList(pageNumber);


    }       

    render() {

        const { bewiseUserList, exportbtndisabled} = this.state;
        const { currentPage, PER_PAGE, totalCount, total } = this.state;

 

        return (
            <React.Fragment>
                <AdminLayout>
                    
           <div class="col-lg-12 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">BeWise Internal Users</h4>
                                   
                  <div class="float-right"><a href="/users/bewiseusers/addbewiseuser" class="btn btn-primary btn-sm">Add</a></div>
                   
                  <div class="table-responsive pt-3">
                     <table id="tablebw">
                      <thead class="thead-dark">
                        <tr>
                          <th>
                            <strong>S.No</strong>
                          </th>
                       
                          <th>
                            <strong>Name</strong>
                          </th>
                                                   
                          <th>
                            <strong>Email Id</strong>
                          </th>
                        
                          <th>
                            <strong>Role</strong>
                          </th>
                         
                          <th>
                            <strong>Status</strong>
                          </th>
                          <th>
                            <strong>Action</strong>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                      {bewiseUserList.map((item, i) => {     
                      
                       return <tr>
                          <td>
                          {item.s_no}
                          </td>
                          
                          <td>
                           {item.user_name}
                          </td>
                          
                          <td>
                           {item.email_id}
                          </td>
                          <td>
                            {item.role_name}
                          </td>
                            
                          <td dangerouslySetInnerHTML={{__html: item.status}} />
                          
                          <td  class="actionbtns" dangerouslySetInnerHTML={{__html: item.action}} />                            

                        </tr>

                      })

                      }
                       
                      </tbody>
                    </table>

                    <div class="text-center">
                      
                     <Pagination
                        activePage={this.state.activePage}
                        itemsCountPerPage={PER_PAGE}
                        totalItemsCount={this.state.total}
                        pageRangeDisplayed={5}
                        activeClass={"pagination__link--active"}
                        onChange={this.handlePageChange.bind(this)}
                        prevPageText="previous"
                        nextPageText="next"
                      />

                    </div>

                  </div>
                </div>
              </div>
            </div>
            <NotificationContainer/>
                </AdminLayout>
            </React.Fragment>
        )
    }
}


export default bewiseUsers;


// WEBPACK FOOTER //
// ./src/components/bewise/bewiseUsers.jsx